import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  root: {
    margin: '0 24px 24px 0',
    padding: 0,
  },
}));
